import { memo, useEffect } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
//Local files
import ManagerSessionsList from './Sessions/List/List';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useApp from 'hooks/useApp';
import useCustomSelector from 'hooks/useCustomSelector';
import useManagers from 'hooks/useManagers';
import { managersSelectors } from 'features/managers';

const UsersDetails = () => {
  const { setManagerDrawer } = useApp();
  const { clearLocalActiveManager } = useManagers();
  const { id, first_name, last_name, email, updated_at } = useCustomSelector(managersSelectors.getManagerData);
  const name = `${first_name} ${last_name}`;
  const lastLogin = new Date(updated_at).toLocaleDateString('en-US');

  useEffect(() => {
    return clearLocalActiveManager;
  }, [clearLocalActiveManager]);

  return (
    <Box sx={{ flexGrow: 1, overflow: 'auto', p: 5  }}>
      <Container maxWidth={'sm'}>
        <Card sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '8px', mb: 1.5  }}>
            <Typography sx={{ fontSize: '2rem', fontWeight: 800 }}>{name}</Typography>
            <Button variant='outlined' onClick={() => setManagerDrawer({ open: true, edit: true })}>Edit</Button>
          </Box>
          <Typography variant='subtitle1'>Email: {email}</Typography>
          <Typography variant='body1' mb={2}>Last login: {lastLogin}</Typography>
        </Card>
        <Card sx={{ p: 2, mt: 3 }}>
          <Typography sx={{ fontSize: '2rem', fontWeight: 800 }}>Sessions</Typography>
          <Box sx={{ m: 2, maxHeight: '500px', overflow: 'auto' }}>
            <ManagerSessionsList manager_id={id} />
          </Box>
        </Card>
      </Container>
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <UsersDetails {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);